export const BUTTON_THEME = {
  TRANSPARENT_WHITE: 'transparent-white'
};
